<template>
    <form class="form-horizontal">
        <div class="form-group">
            <label for="angle_value" class="col-sm-2 control-label">Angulo (graus):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="valor"  class="form-control" id="angle_value" >
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Comandos} from "../../../class";
    import {Bus} from '../../../class/bus';
    export default {
        name: "Angle",
        props: {
            id_rastreador: {
                default: null
            }
        },
        data () {
            return {
                valor
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Comandos.sendAngle(this.id_rastreador, this.valor);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
